<template>
  <v-alert type="error" prominent dense dismissible border="left" :value="flag" @input="onInput">
    <strong>{{ message }}</strong>
  </v-alert>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import Store from '@/store';
import { undoWarn } from '@/libs/store/warn';

const props = Vue.extend({
  props: {
    messages: { type: Object, default: {} },
  },
});

@Component
export default class WarnMessage extends props {
  get flag(): boolean {
    return Store.getters.warn.flag;
  }

  get msg(): string {
    return Store.getters.warn.msg;
  }

  get message(): string {
    if (this.flag) {
      const msg = this.msg;
      return this.messages[msg] || msg;
    }
    return '';
  }

  private onInput(flag: boolean) {
    if (!flag) {
      undoWarn();
    }
  }
}
</script>
